import { FC } from 'react';
import { Loader2 } from 'lucide-react';
import { useVideoCallContext } from '../../../../../contexts/VideoCallProvider';
import { CourseHearingConfirmation } from '../CourseHearingConfirmation/CourseHearingConfirmation';
import { VideoCallModal } from '../VideoCallModal/VideoCallModal';

interface VideoCallSessionProps {
  videoCallId: string;
  isOpen: boolean;
  onClose: () => void;
}

export const VideoCallSession: FC<VideoCallSessionProps> = () => {
  const { videoCall, twilioToken, isConfirmed } = useVideoCallContext();

  if (!videoCall || !twilioToken) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 animate-spin text-neutral-500" />
          <p className="text-neutral-600 text-sm">Joining video call...</p>
        </div>
      </div>
    );
  }

  if (!isConfirmed) {
    return <CourseHearingConfirmation />;
  }

  return <VideoCallModal videoCall={videoCall} twilioToken={twilioToken} />;
};
